import { Component, inject, input } from '@angular/core';
import { MultiSelectInputComponent } from '../../../../kit/input/multi-select-input/multi-select-input.component';
import { fb } from 'packages/client/src/app/modules/shared/shared.global-service';
import { SelectUserRuleStore } from './select-user-rule.store';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-select-user-rule',
    templateUrl: './select-user-rule.component.html',
    styleUrls: ['./select-user-rule.component.scss'],
    providers: [SelectUserRuleStore],
    imports: [
        MultiSelectInputComponent,
    ]
})
export class SelectUserRuleComponent {

    public readonly store = inject(SelectUserRuleStore);

    public disabled = input(false);
    public globalAcl = input(false);
    public form = input<FormGroup>(fb.group({
        ruleIds: fb.control<number[]>([]),
    }));

}
